/**
* 手动录入
*/
const entering = {
  
setQuantitiesHour: "/api/setQuantitiesHour",//写入统计量
setQuantitiesDay: "/api/setQuantitiesDay",//写入统计量
setQuantitiesMonth: "/api/setQuantitiesMonth",//写入统计量
setQuantitiesYear: "/api/setQuantitiesYear",//写入统计量
setMeasuringRawValueForCount: "/api/setMeasuringRawValueForCount",//写入累计量（表读数）
}

export default entering